"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = void 0;
const color_transforms_1 = __importDefault(require("./color/color.transforms"));
const duration_transforms_1 = __importDefault(require("./duration/duration.transforms"));
const easing_transforms_1 = __importDefault(require("./easing/easing.transforms"));
const font_transforms_1 = __importDefault(require("./font/font.transforms"));
const fontFamily_transforms_1 = __importDefault(require("./fontFamily/fontFamily.transforms"));
const fontWeight_transforms_1 = __importDefault(require("./fontWeight/fontWeight.transforms"));
const shadow_transforms_1 = __importDefault(require("./shadow/shadow.transforms"));
const unit_transforms_1 = __importDefault(require("./unit/unit.transforms"));
const radius_transforms_1 = __importDefault(require("./radius/radius.transforms"));
const viewport_transforms_1 = __importDefault(require("./viewport/viewport.transforms"));
exports.css = {
    color: color_transforms_1.default,
    duration: duration_transforms_1.default,
    easing: easing_transforms_1.default,
    font: font_transforms_1.default,
    fontFamily: fontFamily_transforms_1.default,
    fontWeight: fontWeight_transforms_1.default,
    shadow: shadow_transforms_1.default,
    unit: unit_transforms_1.default,
    radius: radius_transforms_1.default,
    viewport: viewport_transforms_1.default,
};
